import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { SPONSOR_VALUE } from "../keys";

const useSponsorValue = (sponsorObjectId, tracked = false) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }
  return useQuery({
    queryKey: [SPONSOR_VALUE, tenant.id, sponsorObjectId, startDate, endDate, tracked],
    queryFn: () => ApiService.getSponsorValue(sponsorObjectId, since, until, tracked),
    select: (data) => JSON.parse(JSON.stringify(data.data.graphs)),
    enabled,
    placeholderData: { data: { graphs: [] } },
  });
};

export default useSponsorValue;
